import styled from "styled-components"

import uniThumbsUp from "images/character/uni_thumbs_up-239x300.png"

export default function DefaultEmpty({ description, callback }) {
  return (
    <Section>
      <CharectorImgBlock>
        <CharectorImg src={uniThumbsUp} />
      </CharectorImgBlock>
      <Description>{description}</Description>
      {callback && <ButtonStyle onClick={callback}>인증 시작하기</ButtonStyle>}
    </Section>
  )
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: calc(100vw * (144 / 375));
  width: 100%;
  height: 100%;
  background-color: #f7f7f7;
`

const CharectorImgBlock = styled.div`
  width: calc(100vw * (83 / 375));
  height: calc(100vw * (100 / 375));
  margin-bottom: calc(100vw * (11 / 375));
`

const CharectorImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const Description = styled.p`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (23 / 375));
  color: #7f7f7f;
  text-align: center;
  white-space: pre-wrap;
`

const ButtonStyle = styled.button`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (23 / 375));
  border-radius: calc(100vw * (10 / 375));
  margin-top: calc(100vw * (15 / 375));
  padding: calc(100vw * (13 / 375)) 0;
  width: calc(100vw * (133 / 375));
  background-color: #ffcf19;
`
